import { render, staticRenderFns } from "./Hub.vue?vue&type=template&id=3df8bbba&scoped=true&"
import script from "./Hub.vue?vue&type=script&lang=js&"
export * from "./Hub.vue?vue&type=script&lang=js&"
import style0 from "./Hub.vue?vue&type=style&index=0&id=3df8bbba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8bbba",
  null
  
)

export default component.exports